<div>
  <dgx-profile-settings-header></dgx-profile-settings-header>

  <div *ngIf="!isLoading">
    <dgx-settings-managed-profile
      *ngIf="options.isManagedProfile"
      [message]="messages.managedProfileMessage"
    >
    </dgx-settings-managed-profile>

    <!-- Displays when "Prevent Public Profiles" or "Lock Profile Privacy" are enabled in ops tool, but not when profile is managed -->
    <dgx-settings-managed-profile
      *ngIf="
        profilePrivacySettingsAreManaged && !options.isManagedProfile && hasOrg
      "
      [message]="privacyLockedMessage"
    >
    </dgx-settings-managed-profile>

    <dgx-profile-settings-error-message
      [show]="options.hasSettingsError"
      [message]="messages.saveSettingsErrorMsg"
    >
    </dgx-profile-settings-error-message>
  </div>

  <dgx-user-settings-nav
    *ngIf="!isLoading"
    [hideIntegrationsTab]="hideIntegrations"
    [hideExtension]="options.hideExtensionTab"
    [hasSocialIntegrations]="hasSocialIntegrations"
    [isClientProvider]="isClientProvider"
    [showFamily]="showFamily"
  ></dgx-user-settings-nav>
  <h1
    *ngIf="isLoading"
    class="h1 skeleton__line skeleton__line--medium bg-animate guts-m-h-1-half guts-m-t-1-half m-guts-m-h-1"
    [style.width]="isMobile ? 'auto' : '93rem'"
  ></h1>

  <div *ngIf="!isLoading">
    <div class="grid__col-12 grid__col--bleed guts-m-t-3 m-guts-m-t-1">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </div>

  <div *ngIf="isLoading">
    <dgx-profile-settings-loading-skeleton
      [isMobile]="isMobile"
    ></dgx-profile-settings-loading-skeleton>
  </div>

  <div class="guts-m-t-3 m-guts-m-t-1 p-settings">
    <dgx-footer-glasses></dgx-footer-glasses>
  </div>
</div>
